
// load jquery
import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

// globals
let $OptionsGallerySlider;
let $OptionsGallerySliderNav;
let $ProductGallerySlider;
let tooltips;
let reload_cart_summary;

// pull in our vendors
require('bootstrap');
require('popper.js');
require('slick-carousel');
require('imagesloaded');
require('lightgallery');
global.Cookies = require('js-cookie');
require('datatables.net-dt');
require('clipboard');

// lib files
require('./lib/common');
require('./lib/products');
require('./lib/shop');
require('./lib/util');
require('./lib/forms');
require('./lib/account');

// import video js
import videojs from 'video.js';

// document ready
jQuery(document).ready(function ($) {

    // if on homepage or plate builder
    if( $('BODY').hasClass('home') ) {

        let bannerVideo = videojs('my-video', {
            preload: 'auto',
            muted: true,
            autoplay: true,
            controls: false,
            loop: true,
            width: 1280,
            height: 720
        });

        // enable tooltips for everything
        const bannerVideoCover = function () {

            console.log('tets');

            // remove banner width style attribute
            $('.video-container', '#home-banner').removeAttr('style');

            // get the banner height
            let banner = {
                height: $('#home-banner').outerHeight()
            };

            // get the video height
            let video = {
                height: $('VIDEO', '#home-banner').outerHeight()
            };

            // if banner height is greater than video height
            if (banner.height > video.height) {

                // percentage increase width value to make video cover banner
                let percentage = (100 / video.height) * banner.height;

                // apply the width to the banner
                $('.video-container', '#home-banner').attr('style', 'width:' + percentage + '%;');

            }

        };

        // banner video function
        bannerVideoCover();

        $(window).on('resize', function () {

            // banner video function
            bannerVideoCover();

        });

    }

    // scroll to action
    $(document).on('click','A[href^="#"]', function(e) {

        // target element id
        var id = $(this).attr('href');

        // target element
        var $id = $(id);
        if ($id.length === 0) {
            return;
        }

        // prevent standard hash navigation
        e.preventDefault();

        // top position relative to the document
        let anchor = $id.offset().top;

        // animated top scrolling
        $('HTML, BODY').animate({
            scrollTop: anchor
        }, 500);

    });

});




